<img
  class="w-5.5 h-5.5 rounded-full object-cover shrink-0"
  [src]="avatarSource"
/>
